import component from "./ManageFoldersModal";
export default component;
